var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusStopped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.037 96c0-51.375-41.662-93.037-93.037-93.037C44.625 2.963 2.963 44.625 2.963 96c0 51.375 41.662 93.037 93.037 93.037 51.375 0 93.037-41.662 93.037-93.037z",
    style: {
      fill: "#f44336",
      fillOpacity: 1
    },
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.461 62.638H65.54a2.91 2.91 0 0 0-2.901 2.9v60.923a2.91 2.91 0 0 0 2.9 2.901h60.923a2.91 2.91 0 0 0 2.901-2.9V65.538a2.91 2.91 0 0 0-2.9-2.901z",
    style: {
      fill: "#fff",
      strokeWidth: 0.77361828
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusStopped);
export default __webpack_public_path__ + "static/media/status-stopped.0189cc2afda967ea8cbf90c4bf7c6a12.svg";
export { ForwardRef as ReactComponent };